/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Tue, 24 Mar 2026 18:28:47 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import {
  CurrencyCodeType,
  CurrencyWithSwiftFlag,
  DashboardOperation,
  DashboardOperationDestination,
  FundingMethodItem,
  PaymentRailType,
} from '@/types/currency';
import { isBoolean, isString, isStringOrNull } from '@/types/common-type-guards';

const valuesOfPaymentRailType: readonly string[] = [
  'COP',
  'PIX',
  'SPEI',
  'CVU',
  'ACH',
  'RTP',
  'WIRE',
  'POLYGON',
  'LOCAL_EXCHANGE',
  'TRON',
  'ETH',
  'SWIFT',
  'CALIZA_WALLET',
  '',
];

export const isPaymentRailType = (value: unknown): value is PaymentRailType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfPaymentRailType.includes(value);
};

export const isPaymentRailTypeOrNull = (value: unknown): value is PaymentRailType | null => {
  return value === null || isPaymentRailType(value);
};

export const isArrayOfPaymentRailType = (value: unknown): value is PaymentRailType[] => {
  return Array.isArray(value) && value.every(isPaymentRailType);
};

export const isArrayOfPaymentRailTypeOrNull = (
  value: unknown,
): value is PaymentRailType[] | null => {
  return value === null || isArrayOfPaymentRailType(value);
};

const valuesOfCurrencyCodeType: readonly string[] = [
  'USDC',
  'USDT',
  'USD',
  'BRL',
  'MXN',
  'COP',
  'ARS',
  'HKD',
  'SGD',
  'ANY',
  '',
];

export const isCurrencyCodeType = (value: unknown): value is CurrencyCodeType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCurrencyCodeType.includes(value);
};

export const isCurrencyCodeTypeOrNull = (value: unknown): value is CurrencyCodeType | null => {
  return value === null || isCurrencyCodeType(value);
};

export const isArrayOfCurrencyCodeType = (value: unknown): value is CurrencyCodeType[] => {
  return Array.isArray(value) && value.every(isCurrencyCodeType);
};

export const isArrayOfCurrencyCodeTypeOrNull = (
  value: unknown,
): value is CurrencyCodeType[] | null => {
  return value === null || isArrayOfCurrencyCodeType(value);
};

export const isCurrencyWithSwiftFlag = (value: unknown): value is CurrencyWithSwiftFlag => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currency' in value && isCurrencyCodeType(value.currency))) return false;
  if (!('swift' in value && isBoolean(value.swift))) return false;

  return true;
};

export const isCurrencyWithSwiftFlagOrNull = (
  value: unknown,
): value is CurrencyWithSwiftFlag | null => {
  return value === null || isCurrencyWithSwiftFlag(value);
};

export const isArrayOfCurrencyWithSwiftFlag = (
  value: unknown,
): value is readonly CurrencyWithSwiftFlag[] => {
  return Array.isArray(value) && value.every(isCurrencyWithSwiftFlag);
};

export const isArrayOfCurrencyWithSwiftFlagOrNull = (
  value: unknown,
): value is readonly CurrencyWithSwiftFlag[] | null => {
  return value === null || isArrayOfCurrencyWithSwiftFlag(value);
};

const propertiesOfCurrencyWithSwiftFlag: readonly string[] = ['currency', 'swift'];

export const isKeyOfCurrencyWithSwiftFlag = (
  value: unknown,
): value is keyof CurrencyWithSwiftFlag => {
  return typeof value === 'string' && propertiesOfCurrencyWithSwiftFlag.includes(value);
};

export const isFundingMethodItem = (value: unknown): value is FundingMethodItem => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('method' in value && isPaymentRailType(value.method))) return false;
  if (!('currency' in value && isCurrencyCodeType(value.currency))) return false;
  if ('fundingSource' in value && !isStringOrNull(value.fundingSource)) return false;

  return true;
};

export const isFundingMethodItemOrNull = (value: unknown): value is FundingMethodItem | null => {
  return value === null || isFundingMethodItem(value);
};

export const isArrayOfFundingMethodItem = (
  value: unknown,
): value is readonly FundingMethodItem[] => {
  return Array.isArray(value) && value.every(isFundingMethodItem);
};

export const isArrayOfFundingMethodItemOrNull = (
  value: unknown,
): value is readonly FundingMethodItem[] | null => {
  return value === null || isArrayOfFundingMethodItem(value);
};

const propertiesOfFundingMethodItem: readonly string[] = [
  'id',
  'method',
  'currency',
  'fundingSource',
];

export const isKeyOfFundingMethodItem = (value: unknown): value is keyof FundingMethodItem => {
  return typeof value === 'string' && propertiesOfFundingMethodItem.includes(value);
};

export const isDashboardOperationDestination = (
  value: unknown,
): value is DashboardOperationDestination => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currency' in value && isCurrencyCodeType(value.currency))) return false;
  if (!('rail' in value && isPaymentRailType(value.rail))) return false;
  if (!('fundingMethods' in value && isArrayOfPaymentRailType(value.fundingMethods))) return false;

  return true;
};

export const isDashboardOperationDestinationOrNull = (
  value: unknown,
): value is DashboardOperationDestination | null => {
  return value === null || isDashboardOperationDestination(value);
};

export const isArrayOfDashboardOperationDestination = (
  value: unknown,
): value is readonly DashboardOperationDestination[] => {
  return Array.isArray(value) && value.every(isDashboardOperationDestination);
};

export const isArrayOfDashboardOperationDestinationOrNull = (
  value: unknown,
): value is readonly DashboardOperationDestination[] | null => {
  return value === null || isArrayOfDashboardOperationDestination(value);
};

const propertiesOfDashboardOperationDestination: readonly string[] = [
  'currency',
  'rail',
  'fundingMethods',
];

export const isKeyOfDashboardOperationDestination = (
  value: unknown,
): value is keyof DashboardOperationDestination => {
  return typeof value === 'string' && propertiesOfDashboardOperationDestination.includes(value);
};

export const isDashboardOperation = (value: unknown): value is DashboardOperation => {
  if (value === null || typeof value !== 'object') return false;
  if (!('currency' in value && isCurrencyCodeType(value.currency))) return false;
  if (!('destinations' in value && isArrayOfDashboardOperationDestination(value.destinations)))
    return false;

  return true;
};

export const isDashboardOperationOrNull = (value: unknown): value is DashboardOperation | null => {
  return value === null || isDashboardOperation(value);
};

export const isArrayOfDashboardOperation = (
  value: unknown,
): value is readonly DashboardOperation[] => {
  return Array.isArray(value) && value.every(isDashboardOperation);
};

export const isArrayOfDashboardOperationOrNull = (
  value: unknown,
): value is readonly DashboardOperation[] | null => {
  return value === null || isArrayOfDashboardOperation(value);
};

const propertiesOfDashboardOperation: readonly string[] = ['currency', 'destinations'];

export const isKeyOfDashboardOperation = (value: unknown): value is keyof DashboardOperation => {
  return typeof value === 'string' && propertiesOfDashboardOperation.includes(value);
};
